<template>
  <div class="examination">
    <div class="examination-side">
      <ExamInfoSide />
    </div>
    <div class="examination-main box-shadow">
      <ExamBody v-model="index" />
    </div>
    <div class="examination-side">
      <ExamOrderSide v-model="index" />
    </div>
  </div>
</template>

<script>
import ExamInfoSide from '../components/ExamInfoSide'
import ExamOrderSide from '../components/ExamOrderSide'
import ExamBody from '../components/ExamBody'

export default {
  components: { ExamInfoSide, ExamOrderSide, ExamBody },
  data () {
    return {
      courseId: this.$route.params.courseId,
      index: 0
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.examination {
  display: flex;
  height: calc(100vh - 36px - 10px - 20px - 50px);
  align-items: stretch;

  &-side {
    flex: 1;
    overflow-y: auto;
    padding: 0 5px;
  }
  &-main {
    flex: 1.5;
    margin: 0 10px;
  }
}
</style>

